module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NextPay","short_name":"NextPay","start_url":"/","theme_color":"#000000","background_color":"#ffffff","display":"standalone","icon":"src/images/favicon/android-chrome-512x512.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"52550f37663669a8bff99f11eee7295f"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-152937531-1","head":true,"anonymize":false,"pageTransitionDelay":0},
    },{
      plugin: require('../node_modules/gatsby-plugin-mixpanel/gatsby-browser.js'),
      options: {"plugins":[],"apiToken":"94ca352179df6fc750d3a7b85f7ad160","enableOnDevMode":true,"mixpanelConfig":null,"pageViews":"all","trackPageViewsAs":"Page view"},
    },{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-10},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
